import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { dataModel } from '../../models/data.model';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { AuthenticationService } from '../../common/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
  encapsulation: ViewEncapsulation.None
})

export class LoginComponent implements OnInit {
  @Input() data: dataModel;
  innerWidth: any;
  submitted = true;
  loginForm: FormGroup;
  err = true;
  returnUrl: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService) {
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
     }

  ngOnInit() {

    this.loginForm  =  this.formBuilder.group({
      username: [null, Validators.required],
      password: [null, Validators.required],
      token: [null,  Validators.required],
    });

    this.returnUrl = this.route.snapshot.params.id || this.route.snapshot.queryParams.returnUrl || '/';

  }

  public resolved(captchaResponse: any) {
    this.loginForm.controls.token.setValue(captchaResponse);
  }

  login() {
    this.submitted = false;
    if (this.loginForm.invalid) {
        return this.submitted = true;
    } else {
       this.authenticationService
       .login(this.loginForm.controls.username.value,
              this.loginForm.controls.password.value,
              this.loginForm.controls.token.value).pipe(first())
              .subscribe(
                  data => {
                    if (Object.keys(data).length > 0) {
                        this.submitted = false;
                        this.router.navigate([this.route.snapshot.params.id ? '/industries/' + this.returnUrl : this.returnUrl]);
                    }
                    this.submitted = true;
                    this.err = false;
                  },
                  error => {
                      console.log('Error: ' + error);
                      this.submitted = true;
                  });
    }
  }
}
